import { Container, Heading, Text, Box } from '@chakra-ui/react';
import PillPity from 'pill-pity';

import { Logo } from '@/components/common/Logo';
import { Head } from '@/components/Head';
import * as LC from '@/components/LC';

type AuthLayoutProps = {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
};

export const AuthLayout = ({ children, title, subtitle }: AuthLayoutProps) => {
  return (
    <>
      <Head title={title} />
      <PillPity
        pattern="topography"
        as={LC.Vertical}
        center
        position="relative"
        w="100%"
        minH="100vh"
        pb="5%"
        pt={10}
        bgColor="brand.500"
        patternFill="whiteAlpha.300"
        patternOpacity={0.3}
      >
        <Box p={3} bg="white" shadow="md" maxW="3xs" mx="auto" rounded="lg" mb={8}>
          <Logo />
        </Box>
        <Container maxW="container.md">
          <LC.Vertical
            center
            w="60%"
            bg="white"
            mx="auto"
            py={8}
            px={12}
            borderRadius="lg"
            boxShadow="md"
          >
            {title && (
              <Heading as="h1" fontSize="2xl" mb={8} textTransform="uppercase" textAlign="center">
                {title}
              </Heading>
            )}
            {subtitle && (
              <Text
                fontSize="sm"
                maxW="60%"
                mb={12}
                fontWeight="normal"
                textAlign="center"
                mx="auto"
              >
                {subtitle}
              </Text>
            )}
            {children}
          </LC.Vertical>
        </Container>
      </PillPity>
    </>
  );
};
